import { definePreset } from '@primeuix/themes'
import Nora from '@primeuix/themes/nora'

const radiusAutoPreset = definePreset(Nora, {
	//Your customizations, see the following sections for examples
	primitive: {
		rdusOrangeDark: {
			50: '#ffedeb',
			100: '#ffdad6',
			200: '#ffb4aa',
			300: '#ff8a77',
			400: '#ff571b',
			500: '#d64400',
			600: '#ac3500',
			700: '#832600',
			800: '#5d1800',
			900: '#390c00',
			950: '#270600',
		},
		rdusOrangeLight: {
			50: '#ffedeb',
			100: '#ffdad7',
			200: '#ffb7b0',
			300: '#ff8e7f',
			400: '#ff6241',
			500: '#e34300',
			600: '#b73400',
			700: '#892500',
			800: '#621800',
			900: '#3a0a00',
			950: '#280500',
		},
	},
	semantic: {
		primary: {
			50: '#dbedff',
			100: '#b8dfff',
			200: '#4fc0ff',
			300: '#009dd9',
			400: '#007aa9',
			500: '#00577a',
			600: '#004765',
			700: '#00374e',
			800: '#002739',
			900: '#001825',
			950: '#000d16',
		},
		colorScheme: {
			light: {
				surface: {
					0: '#f3f3f6',
					50: '#f3f3f6',
					100: '#e6e8ed',
					200: '#cacfda',
					300: '#b2b9c9',
					400: '#9aa3b9',
					500: '#838ea8',
					600: '#6d778e',
					700: '#5b6376',
					800: '#495060',
					900: '#262a33',
					950: '#15181e',
				},
			},
		},
	},
	components: {
		button: {
			root: {
				borderRadius: '0'
			}
		}
	}
})

export default radiusAutoPreset
